export default __webpack_public_path__ + "static/media/support.a79d4761.svg";